import { createFileRoute } from "@tanstack/react-router";

import TilesPage from "@/app/admin/tiles/TilesPage";

export const Route = createFileRoute("/admin/tiles")({
  component: TilesPage,
});
